import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { trackPlaybook } from '@/lib/playbookAnalytics';
import cover800 from '@/assets/playbook-1-800.jpg.asset.json';
import p31_800 from '@/assets/playbook-31-800.jpg.asset.json';

const HREF = '/ai-tools-playbook';

export function PlaybookFeature() {
  const click = () => trackPlaybook('playbook_promo_click', 'homepage_playbook');
  return (
    <section className="container mx-auto px-4 pt-10" aria-labelledby="home-playbook-title">
      <div className="max-w-6xl mx-auto overflow-hidden rounded-3xl border border-playbook-yellow/60 bg-playbook-pale text-playbook-ink shadow-[0_12px_32px_-18px_hsl(var(--playbook-ink)/0.35)]">
        <div className="grid md:grid-cols-[1.15fr_1fr] items-center gap-6 md:gap-8 p-6 md:p-10">
          <div>
            <p className="text-xs font-semibold tracking-[0.14em] uppercase mb-3 flex items-center gap-2">
              <span className="inline-block h-2 w-2 rounded-full bg-playbook-yellow" aria-hidden />
              From AI ToolHub · The AI Tools Playbook
            </p>
            <h2 id="home-playbook-title" className="font-display text-3xl md:text-4xl font-bold tracking-tight leading-tight mb-3">
              Found the tools. Now put them to work.
            </h2>
            <p className="text-base md:text-lg text-playbook-ink/80 mb-4 max-w-xl">
              Turn everyday tasks into finished work with 18 step-by-step AI workflows, ready-to-adapt prompts, and worked examples.
            </p>
            <p className="inline-block text-sm font-semibold border-l-4 border-playbook-yellow pl-3 mb-6">
              9 chapters · 18 workflows · 60 prompts
            </p>
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
              <Button size="lg" asChild className="w-full sm:w-auto focus-visible:ring-offset-playbook-pale">
                <Link to={HREF} onClick={click}>Explore the Playbook — $29 USD</Link>
              </Button>
              <Link
                to={HREF}
                onClick={click}
                className="text-sm font-semibold underline-offset-4 hover:underline rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-playbook-ink text-center sm:text-left"
              >
                Take a look inside <ArrowRight className="inline h-4 w-4" aria-hidden />
              </Link>
            </div>
            <p className="mt-3 text-sm text-playbook-ink/75">One-time purchase · Guide + prompt pack in PDF and Word</p>
          </div>

          <div className="relative mx-auto w-full max-w-[260px] md:max-w-[380px] h-[220px] md:h-[360px]" aria-hidden={false}>
            <img
              src={p31_800.url}
              alt="Interior page of The AI Tools Playbook showing example social graphics and completion checks"
              width={800}
              height={1131}
              loading="lazy"
              decoding="async"
              className="hidden sm:block absolute right-0 top-4 md:top-6 w-[48%] rounded-md border border-playbook-ink/10 shadow-lg rotate-[4deg]"
            />
            <img
              src={cover800.url}
              alt="Cover of The AI Tools Playbook digital guide: Stop testing tools. Start finishing work."
              width={800}
              height={1131}
              loading="lazy"
              decoding="async"
              className="absolute left-1/2 sm:left-[8%] -translate-x-1/2 sm:translate-x-0 top-0 h-full w-auto rounded-md border border-playbook-ink/10 shadow-xl -rotate-[2deg]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
